import { render } from "./AssetAccess.vue?vue&type=template&id=7b7d7b42"
import script from "./AssetAccess.vue?vue&type=script&lang=js"
export * from "./AssetAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
